<div class="mx-5 mb-5" id="myPdf" *ngIf="deliveryRequests">
  <div
    class="mx-5 my-0 print-wrap page{{ j + 1 }}"
    id="page{{ j }}"
    *ngFor="let item of slices; let j = index"
  >
    <div class="row mx-5 mt-5">
      <div class="col-6 text-left">
        <img
          class="img-fluid"
          style="width: 60%"
          src="../../../assets/img/modal/intigrow.png"
        />

        <p>24 rue Ibn hazem Andalousie,</p>
        <p>Menzah 6 Ariana</p>
        <p>Tél : 56 83 76 52</p>
        <p>info@intigo.tn</p>
        <p>www.intigo.tn</p>

        <p>Date: {{ today | date: "dd/MM/yyyy hh:mm" }}</p>
      </div>
      <div class="col-6 text-center mt-3">
        <h3>RETOUR :</h3>
        <!-- <qrcode [qrdata]="item.qrCode" [width]="128" [height]="128" [errorCorrectionLevel]="'M'"></qrcode>
                <br> -->

        <p>
          <b>Client </b> : {{ deliveryRequests[0].business?.nomCommercial }}
        </p>
        <p><b>MF/CIN </b>:</p>
        <p class="ar">
          <b>Adresse </b> : {{ item?.requests[0]?.pickUp?.pickUpAddress }}
        </p>
        <p>
          <b>Numéro de téléphone </b> : {{ item?.requests[0]?.business?.tel }}
        </p>
      </div>
    </div>
    <div class="row mx-5 pb-5">
      <table class="table table-striped">
        <thead class="items-header-section table-header">
          <tr>
            <th scope="col">Numéro</th>
            <th scope="col">Date</th>
            <th scope="col">Nom de client</th>
            <th scope="col">Nom de client finale</th>
            <th scope="col">Numéro de téléphone</th>
            <th scope="col" *ngIf="item?.requests[0]?.pickUp?.pickUpAddress">
              Adresse de ramassage
            </th>
            <th scope="col">Prix</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let req of slices[j].requests; let i = index">
            <th scope="row">{{ req?.nid }}</th>
            <td>{{ req?.pickUpJob?.startDate | date: "M/d/yyyy" }}</td>
            <td>{{ req?.business?.nomCommercial }}</td>
            <td>{{ req?.deliveredToName }}</td>
            <td>{{ req?.business?.tel }}</td>
            <td class="ar" *ngIf="item?.requests[0]?.pickUp?.pickUpAddress">
              {{ req?.pickUpJob?.pickUp?.pickUpAddress }}
            </td>
            <td>{{ req?.amount }}DT</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<iframe
  class="d-none"
  frameBorder="0"
  id="sample-pdf"
  style="right: 0; top: 53px; bottom: 0; height: 400px; width: 100%"
></iframe>
